<template>
	<b-card no-body>
		<b-card-header class="border-0">
			<b-row></b-row>
		</b-card-header>
		<b-col cols="12">
			<b-row class="d-flex align-items-center justify-content-md-between">
				<b-col cols="12" md="6" class="d-md-flex">
					<base-input label="Search" v-model="searchQuery" v-on:input="debouncedHandler" prepend-icon="fas fa-search"
						placeholder="Search...(case-sensitive)">
					</base-input>
				</b-col>
			</b-row>
		</b-col>
		<el-table :data="queriedData" style="width: 100%" @selection-change="selectionChange" v-loading="isTableLoading">
			<el-table-column prop="team_group_id" label="ID" sortable min-width="80">
			</el-table-column>
			<el-table-column prop="group_name" label="Name" sortable width="150">
				<template slot-scope="scope">
					<a @click="toggleHubTeamDetail(scope.row)">
						<p class="font-weight-500 text-primary">{{ scope.row.group_name }}</p>
					</a>
				</template>
			</el-table-column>
			<el-table-column prop="user.name" label="Hub Manager" sortable min-width="150">
				<template slot-scope="scope">
					<span class="text-break">{{ scope.row.group_owner.name }}</span>
					<div class="text-break" v-if="_gHlp.getValue(scope.row, 'group_sub_owner.name')"><b>Assistant Manager:</b> {{
						_gHlp.getValue(scope.row, 'group_sub_owner.name') }}</div>
				</template>
			</el-table-column>
			<el-table-column label="Team Leaders" min-width="185">
				<template slot-scope="scope">
					<div v-for="(team, index) in scope.row.teams" :key="team.team_id">
						<div class="px-2 mb-2" v-if="team.team_owner">
							{{ team.team_owner.name }}
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="Team Members" min-width="185">
				<template slot-scope="scope">
					<div v-for="team in scope.row.teams" :key="team.team_id">
						<p><b>{{ team.team_name }}</b></p>
						<el-tooltip v-for="member in team.team_members" :key="member.id" placement="bottom" effect="dark">
							<div slot="content">
								Name: {{ member.name }}
							</div>
							<b-avatar size="32px" :text="getUserInitials(member.name)"></b-avatar>
						</el-tooltip>
					</div>
				</template>
			</el-table-column>
			<el-table-column width="30" class-name="px-1">
				<template slot-scope="scope">
					<el-dropdown :tabindex="scope.row.team_group_id" class="py-2">
						<b class="el-dropdown-link">
							<b-icon icon="three-dots-vertical">
							</b-icon>
						</b>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="onDelete(scope.row)">
								<span class="text-danger">
									<b-icon-trash></b-icon-trash>
									<span class="text-danger">Delete</span>
								</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>
		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap">
			<div class="d-flex align-items-center mb-3">
				<p class="card-category mb-0 text-secondary">
					Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>

				<span class="mb-0 ml-4">Rows:</span>

				<el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage" placeholder="Per page">
					<el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
						:value="item">
					</el-option>
				</el-select>

			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="total" @change="paginationChanged($event)">
			</base-pagination>
		</div>

		<modal :show.sync="modals.edit_hub" modalClasses="medium-sized-modal">
			<h6 slot="header" class="modal-title">Hub Details</h6>
			<b-form @submit.prevent="updateData">
				<b-row>
					<b-col md="12" cols="12">
						<b-form-group label="Hub Name:" label-cols-xl="3">
							<b-form-input v-model="form.group_name" placeholder="Enter name" required></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="12" cols="12">
						<b-form-group label="Hub Manager:" label-cols-xl="3">
							<el-select v-model="form.group_owner_id" filterable placeholder="Select Hub Manager">
								<el-option v-for="option in userList" :key="option.id" :label="option.name" :value="option.id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<!-- <b-col md="6" cols="12">
                        <b-form-group label="Total Target" label-cols-xl="3">
                            <b-form-input
                            v-model="form.name"
                            placeholder="Enter target"
                            required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="Member Target (RM):" label-cols-xl="3">
                            <b-form-input
                            v-model="form.name"
                            placeholder="Enter target"
                            required
                            ></b-form-input>
                        </b-form-group>
                    </b-col> -->
				</b-row>
				<div>
					<b-button type="button" class="btn btn-secondary float-right mx-2"
						@click="toggleCreateModal()">Back/Close</b-button>
					<b-button type="submit" variant="primary" class="btn btn-primary float-right mx-2">Save</b-button>
				</div>
			</b-form>
			<template slot="footer">
				<div></div>
			</template>
		</modal>

		<drawer-hub-team ref="drawer_hub_team" :teamGroupData="teamGroupData"></drawer-hub-team>
	</b-card>
</template>
<script>
import { Table, TableColumn, Option, Select, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import { mapActions, mapState } from 'pinia'
import { axios, services, getHeader, swal, debounce, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useHubStore } from '@/stores/hubStore'
import DrawerHubTeam from '@/views/Hub/HubDetails/DrawerHubTeam'
import mainEventBus from '@/assets/js/mainEventBus.js'

export default {
	name: 'hub-listing-table',
	mixins: [notifyFunctionMixin, clientPaginationMixin, helperFunctionMixin],
	components: {
		BasePagination,
		DrawerHubTeam,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Option.name]: Option,
		[Select.name]: Select,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
	},
	data() {
		return {
			propsToSearch: ['group_name', 'hub_address'],
			tableData: [],
			currentPage: 1,
			modals: {
				edit_hub: false
			},
			isTableLoading: false,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			form: {},
			teamGroupData: {},
		}
	},
	computed: {
		...mapState(useAccessControlStore, ['userList']),
		...mapState(useHubStore, ['current_team_group'])
	},
	created() {
		this.getUsers(_gAuth.activeCorporateId());
		this.getHubManagerUserList(_gAuth.activeCorporateId());
		this.getTeamManagerUserList(_gAuth.activeCorporateId());
		this.hubList();
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
		}, 500);
		mainEventBus.$on('refresh-hub-listing', this.hubList)
	},
	beforeUnmount() {
		mainEventBus.$off('refresh-hub-listing', this.hubList)
	},
	methods: {
		...mapActions(useAccessControlStore, ['getUsers', 'getHubManagerUserList', 'getTeamManagerUserList']),
		...mapActions(useHubStore, ['setTeamGroup']),
		paginationChanged(page) {
			this.pagination.currentPage = page
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		toggleUpdateModal(row) {
			this.modals.edit_hub = !this.modals.edit_hub;
			this.form = row
		},
		toggleHubTeamDetail(row) {
			this.teamGroupData = this.tableData.find((item) => item.team_group_id == row.team_group_id)
			this.setTeamGroup(this.teamGroupData)
			this.$refs.drawer_hub_team.viewHubTeamDetails()
		},
		hubList() {
			this.isTableLoading = true
			let urlSearchParams = new URLSearchParams();
			urlSearchParams.append('search[application_code]', _gAuth.appCode());
			const url = `${services.commission}team-group?${urlSearchParams.toString()}`
			axios.get(url, { headers: getHeader() })
				.then(response => {
					this.isTableLoading = false
					this.tableData = response.data.data
				})
				.catch(error => {
					this.isTableLoading = false
					this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message)
				});
		},
		updateData() {
			const postData = {
				group_name: this.form.group_name,
				group_owner_id: this.form.group_owner_id,
			}
			axios.put(services.commission + 'team-group/' + this.form.team_group_id, postData, { headers: getHeader() })
				.then(response => {
					this.modals.edit_hub = false
					this.hubList()
				})
				.catch(error => {
					this.errorFunction(error, "Update Hub failed: " + error.response.data.message)
				});
		},
		onDelete(row) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, delete it!',
			}).then((result) => {
				/* Read more about isConfirmed, isDenied below */
				if (result.isConfirmed) {
					axios.delete(services.commission + 'team-group/' + row.team_group_id, { headers: getHeader() })
						.then(response => {
							if (response.status === 200) {
								this.$notify({
									message:
										'<b>Hub : ' + row.hub_name + '</b> - Successfully Deleted.',
									timeout: 10000,
									icon: 'ni ni-bell-55',
									type: 'default',
								});
								this.hubList();
							}
						})
						.catch(error => {
							this.errorFunction(error, "Delete Hub Failed")
						});
				}
			})
		},
	}
}
</script>